import React, { useEffect, useState } from "react";
import { Amplify, API, graphqlOperation } from "aws-amplify";
import CommonSection from "../components/UI/CommonSection";
import Helmet from "../components/Helmet/Helmet";
import AboutSection from "../components/UI/AboutSection";
import { Container, Row, Col } from "reactstrap";
import BecomeDriverSection from "../components/UI/BecomeDriverSection";
import driveImg from "../assets/all-images/drive.jpg";
import "../styles/about.css";
import ProductItem from "../components/UI/ProductItem";
import { listProductCategories } from "../graphql/queries";

const listProductCategoryLinks = [{}];

const GalleryContent = () => {

      const [listProductCat, setlistProductCat] = useState(listProductCategoryLinks)

      useEffect( () => {
         // (async () => {
        fetchTodos()
         // })
     }, [])
      const fetchTodos = async ()=> {
         try {
           const listProductCatData = await API.graphql(graphqlOperation(listProductCategories));
  console.log(listProductCatData, "listProductCatData")

           const _productCategoriesList = listProductCatData?.data?.listProductCategories?.items
           setlistProductCat(_productCategoriesList)
         } catch (err) { console.log(err, 'error fetching listMenu') }
       }

  return (
    <section>
      <Container>
        <Row>
          <Col lg="12 text-center mb-1">
            {/* <h6 className="section__subtitle">Come with</h6> */}
            <h2 className="section__title text-uppercase">Products</h2>
          </Col>
          {listProductCat.slice(0, 6).map((item,i) => (
            <ProductItem item={item} key={i} />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default GalleryContent;
